import {FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl} from '@angular/forms';
import {FormValidator} from "../validators/form.validator";

export class ResetPasswordValidation {

  static createResetPasswordForm(fb: FormBuilder): FormGroup {
    return fb.group({
      email: ['', [FormValidator.requiredField('Email is required.'), Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
    });
  }
}
